<template>
  <v-card outlined style="margin-bottom: 24px">
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Phản hồi với phụ huynh</h5>
      <!-- <v-btn text color="blue darken-4" class="pr-6 document-btn no-hover" plain style="height: 18px" @click="reply">
        <v-icon left>mdi-reply</v-icon>
        Trả lời
      </v-btn> -->
    </div>
    <v-divider></v-divider>
    <div class="message-list pa-6 pb-0">
      <div v-for="(message, index) in messages" :key="index">
        <v-card
          :class="{
            'admin-message': message.senderType === 'admin',
            'parent-message': message.senderType === 'parent',
          }"
          outlined
          class="mb-6 elevation-0"
        >
          <v-card-text>
            <div class="mb-3">
              <MessageSenderCard :message="message" :sender="message.sender" />
            </div>

            <div class="black--text" style="font-size: 16px">
              <span v-html="formatContent(message.content)"></span>
            </div>
            <div v-if="message.data && message.data.length">
              <div v-for="(file, fileIndex) in message.data" :key="fileIndex" class="file-link">
                <a :href="file.url" target="_blank">{{ file.title }}</a>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
    <v-divider></v-divider>
    <div class="pa-6">
      <v-form v-bind="this.$attrs" ref="form">
        <v-textarea label="Phản hồi" v-model="content" outlined class="mb-6" hide-details rows="3"></v-textarea>
        <!-- <v-file-input
          v-model="files"
          show-size
          outlined
          multiple
          counter
          dense
          label="Chọn file tải lên tại đây"
          append-icon="mdi-upload"
          prepend-icon=""
          :clearable="false"
        ></v-file-input> -->
      </v-form>
      <div class="d-flex justify-space-between">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-4" class="white--text" @click="submit" :disabled="!content">TRẢ LỜI</v-btn>
      </div>
    </div>
    <MessageReply :state="dialog" @refresh="refresh" @closeDialog="close" />
  </v-card>
</template>

<script>
import MessageSenderCard from '../../views/student/components/MessageSenderCard.vue'
import MessageReply from './MessageReply.vue'
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      content: '',
      files: null,
    }
  },
  components: { MessageSenderCard, MessageReply },
  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...mapActions('upload', ['uploadFile']),
    ...mapActions('ticketMessage', ['createStudentTicketMessage']),
    reply() {
      this.dialog = true
    },
    close() {
      this.dialog = false
    },
    refresh() {
      this.$emit('refresh')
    },
    formatContent(content) {
      return content.replace(/\n/g, '<br />')
    },
    async submit() {
      if (this.$refs.form.validate()) {
        try {
          this.$loading.active = true
          let data = {
            content: this.content,
            ticket: this.$route.params.id,
            data: [],
          }

          if (this.files && this.files.length > 0) {
            const filePromises = this.files.map(file => {
              const formData = new FormData()
              formData.append('files', file)
              formData.append('refId', this.$route.params.id)
              formData.append('field', 'attachment')
              return this.uploadFiles(formData)
            })

            const responses = await Promise.all(filePromises)
            const uploadedFiles = responses.flat().map(response => ({
              title: response.name,
              url: response.url,
            }))

            data.data = uploadedFiles
          }
          await this.createStudentTicketMessage({ ...data })

          this.refresh()
          this.resetForm()
        } catch (e) {
          this.$alert.error('Lỗi cập nhật ticket')
          console.error(e)
          this.$loading.active = false
        }
      }
    },
    async uploadFiles(formData) {
      return this.uploadFile(formData)
    },
    resetForm() {
      this.content = ''
      this.files = null
      this.$refs.form.resetValidation()
    },
  },
}
</script>

<style>
.no-hover.v-btn--plain .v-btn__content {
  opacity: 1 !important;
}

.message-list {
  max-height: 400px;
  height: 400px;
  overflow-y: auto;
}

.file-link {
  margin-top: 8px;
}

.admin-message {
  margin-left: 50px;
}

.parent-message {
  margin-right: 50px;
}
.footer {
  padding-top: 24px;
}
</style>
